import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import { departmentsRef, regionsRef, profilesRef } from '../api/index';
import {
  REQUEST_TAGS,
  RECEIVE_TAGS,
  PROFILE_CHANGED,
  REGION_CHANGED,
  DEPARTMENT_CHANGED,
  TAGS_CHANGED,
  USER_CHOICES_CHANGED,
  USER_SELECTED,
  ALL_USER_SELECTED,
  ALL_USER_UNSELECTED,
  RESET_STATE,
} from '../actions/diffusion';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  loaded: false,
  items: [],
  region: null,
  department: null,
  profile: null,
  tags: [],
  userChoices: Map(),
  selectedUsers: Map(),
};

const diffusion = createReducer(initialState, {
  [RESET_STATE](state, action) {
    return initialState;
  },
  [REQUEST_TAGS](state, action) {
    return {
      isFetching: true,
      ...state,
    };
  },
  [RECEIVE_TAGS](state, { tags }) {
    return {
      ...state,
      isFetching: false,
      loaded: true,
      items: tags,
    };
  },
  [PROFILE_CHANGED](state, { profile }) {
    return {
      ...state,
      profile: profile,
    };
  },
  [REGION_CHANGED](state, { region }) {
    return {
      ...state,
      region: region,
    };
  },
  [DEPARTMENT_CHANGED](state, { department }) {
    return {
      ...state,
      department: department,
    };
  },
  [TAGS_CHANGED](state, { tags }) {
    return {
      ...state,
      tags: tags,
    };
  },
  [USER_CHOICES_CHANGED](state, { users }) {
    return {
      ...state,
      userChoices: Map(users.map(u => [u.id, u])),
      selectedUsers: Map(),
    };
  },
  [USER_SELECTED](state, { user }) {
    const { selectedUsers } = state;
    if (selectedUsers.has(user.id)) {
      return {
        ...state,
        selectedUsers: selectedUsers.delete(user.id),
      };
    } else {
      return {
        ...state,
        selectedUsers: selectedUsers.set(user.id, user),
      };
    }
  },
  [ALL_USER_SELECTED](state, action) {
    return {
      ...state,
      selectedUsers: state.userChoices,
    };
  },
  [ALL_USER_UNSELECTED](state, action) {
    return {
      ...state,
      selectedUsers: Map(),
    };
  },
});

export const isFilterEmpty = state => {
  return (
    state.diffusion.selection.tags.length === 0 &&
    (state.diffusion.selection.region === null ||
      state.diffusion.selection.region === '') &&
    (state.diffusion.selection.profile === null ||
      state.diffusion.selection.profile === '') &&
    (state.diffusion.selection.department === null ||
      state.diffusion.selection.department === '')
  );
};

export const getSelectedUsers = state => {
  return state.diffusion.selection.selectedUsers;
};

export const getTagsChoices = state => {
  return state.diffusion.selection.items;
};

export const getRegion = state => {
  return state.diffusion.selection.region;
};

export const getDepartment = state => {
  return state.diffusion.selection.department;
};

export const getProfile = state => {
  return state.diffusion.selection.profile;
};

export const getTags = state => {
  return state.diffusion.selection.tags;
};

export const getUsersChoices = state => {
  return state.diffusion.selection.userChoices;
};

export const getDepartmentsChoices = () => {
  return departmentsRef.map(d =>
    Object.assign({}, { key: d.key, name: d.key + ' - ' + d.name })
  );
};

export const getRegionsChoices = () => regionsRef;

export const getProfilesChoices = () => profilesRef;

export default diffusion;



// WEBPACK FOOTER //
// ./src/modules/diffusion/reducers/diffusion.js